import accountSettingsModule from '../accountSettingsModule';

const accountConstantsResources = {
  controllers: {
    modal: {
      emailSet: 'accountSettingsModalEmailSetController',
      emailVerify: 'accountSettingsModalEmailVerifyController',
      passwordSet: 'accountSettingsModalPasswordSetController',
      phoneSet: 'accountSettingsModalPhoneSetController',
      twoStepSet: 'accountSettingsModalTwoStepController',
      pinCreate: 'accountSettingsModalPinCreateController',
      pinUnlock: 'accountSettingsModalPinUnlockController',
      usernameUpdate: 'accountSettingsModalUsernameUpdateController',
      socialDisconnect: 'accountSettingsModalSocialDisconnectController'
    }
  },
  templates: {
    accountInfo: 'account-info',
    accountBilling: 'account-billing',
    accountNotifications: 'account-notifications',
    accountPrivacy: 'account-privacy',
    accountSecurity: 'account-security',
    accountSocial: 'account-social',
    accountPinStatus: 'account-pin-status',
    accountTransactions: 'account-transactions',
    accountFastTrack: 'account-fasttrack',
    modal: {
      emailSet: 'modal-email-set',
      emailVerify: 'modal-email-verify',
      passwordSet: 'modal-password-set',
      phoneSet: 'modal-phone-set',
      twoStepSet: 'modal-two-step-disable',
      pinCreate: 'modal-pin-create',
      pinUnlock: 'modal-pin-unlock',
      usernameUpdate: 'modal-username-update',
      socialDisconnect: 'modal-social-disconnect'
    },
    userAccountBase: 'user-account-base'
  },
  paymentType: {
    paypal: 'paypal'
  },
  paymentsPerPage: 10,
  maxPaymentsLoaded: 25,
  paymentProviderTypeToClass: {
    Visa: 'visa',
    Discover: 'discover',
    MasterCard: 'masterCard',
    AmericanExpress: 'americanExpress',
    Paypal: 'paypal',
    Credit: 'robloxCredit'
  },
  updateThemeEventContext: 'select',
  defaultThemeType: 'Classic',
  updateThemeEvent: 'Roblox.ThemeUpdate',
  themeTypes: {
    classic: 'Classic',
    light: 'Light'
  },
  birthdayPicker: {
    year: {
      id: 'YearDropdown',
      class: 'year',
      name: 'birthYear',
      type: 'year'
    },
    month: {
      id: 'MonthDropdown',
      class: 'month',
      name: 'birthMonth',
      type: 'month'
    },
    day: {
      id: 'DayDropdown',
      class: 'day',
      name: 'birthDay',
      type: 'day'
    }
  },
  defaultDateParts: {
    0: {
      options: [
        {
          label: 'Month',
          value: null
        }
      ],
      id: 'MonthDropdown',
      class: 'month',
      name: 'birthdayMonth',
      type: 'month'
    },
    1: {
      options: [
        {
          label: 'Day',
          value: null
        }
      ],
      id: 'DayDropdown',
      class: 'day',
      name: 'birthdayDay',
      type: 'day'
    },
    2: {
      options: [
        {
          label: 'Year',
          value: null
        }
      ],
      id: 'YearDropdown',
      class: 'year',
      name: 'birthdayYear',
      type: 'year'
    }
  },
  accountSettingsPolicyDefault: {
    displayTwoStepVerification: true,
    displayEmailAddress: true,
    displayWeChat: false,
    displayQQ: false,
    displayConnectedAccounts: true,
    displayNotificationStream: true,
    displayDesktopPush: true,
    displayMobilePush: true,
    displayPhoneNumber: true,
    displaySocialMedia: true,
    displayDescription: true,
    displayAccountRestrictions: true,
    displayWhoCanMessageMe: true,
    displayWhoCanFindMeByPhoneNumber: true,
    displayWhoCanInviteMeToVIPServers: true,
    displayWhoCanTradeWithMe: true,
    displayTradeQualityFilter: true,
    displayCountryList: true,
    displayLanguageList: true,
    displayChangeUsername: true,
    displayChangePassword: true
  },
  accountSettingsPolicyLeastPrivileged: {
    displayTwoStepVerification: false,
    displayEmailAddress: false,
    displayWeChat: false,
    displayQQ: false,
    displayConnectedAccounts: false,
    displayNotificationStream: false,
    displayDesktopPush: false,
    displayMobilePush: false,
    displayPhoneNumber: false,
    displaySocialMedia: false,
    displayDescription: false,
    displayAccountRestrictions: false,
    displayWhoCanMessageMe: false,
    displayWhoCanFindMeByPhoneNumber: false,
    displayWhoCanInviteMeToVIPServers: false,
    displayWhoCanTradeWithMe: false,
    displayTradeQualityFilter: false,
    displayCountryList: false,
    displayLanguageList: false,
    displayChangeUsername: false,
    displayChangePassword: false
  },
  accountSettingsPolicyNotificationDestinations: {
    NotificationStream: 'displayNotificationStream',
    DesktopPush: 'displayDesktopPush',
    MobilePush: 'displayMobilePush'
  },
  counters: {
    accountSettingPolicyPrefix: 'WebsiteAccountSettingsPolicy_',
    success: 'Success',
    failure: 'Failure'
  },
  socialAuth: {
    providers: {
      facebook: 'facebook',
      weChat: 'wechat',
      qq: 'qq'
    }
  },
  socialErrorCode: {
    11: 'Message.Error.InvalidFacebookUrl ',
    12: 'Message.Error.InvalidTwitterUrl',
    13: 'Message.Error.InvalidYouTubeUrl',
    14: 'Message.Error.InvalidTwitchUrl'
  },
  events: {
    formInteractionEventType: 'formInteraction',
    settingsCtx: 'settings',
    addEmailBtn: 'addEmail',
    verifyEmailBtn: 'verifyEmail',
    addPhoneBtn: 'addPhone',
    changeEmailBtn: 'changeEmail',
    changePhoneBtn: 'changePhone',
    toggle2SVOn: 'turn2SVon',
    toggle2SVOff: 'turn2SVoff'
  }
};

accountSettingsModule.constant('accountConstantsResources', accountConstantsResources);

export default accountConstantsResources;
